module.exports = __webpack_public_path__ + "static/media/xicht.ef1a2274.jpg";